import React, {ReactElement} from "react";

import {css} from "/src/utils/utils";
import Image, {ImageObject} from "../../image/Image";
import CTAButton, {CTA} from "../../buttons/cta-button/CTAButton";

import * as styles from "./fast-fact.module.scss";

export interface FastFactProps {
  bgImage?: ImageObject;
  logo?: ImageObject;
  eyebrow?: string;
  headline?: string;
  trailing?: string;
  copy?: string;
  cta?: CTA;
  caption?: string;
  classes?: string;
}

const FastFact = (props: FastFactProps): ReactElement | null => {
  const {
    eyebrow,
    headline,
    trailing,
    copy,
    classes,
    cta,
    caption,
    logo,
    bgImage,
  } = props;

  if (
    !eyebrow &&
    !headline &&
    !trailing &&
    !copy &&
    !cta &&
    !caption &&
    !logo &&
    !bgImage
  ) {
    return null;
  }

  return (
    <div className={css(styles.fastFact, classes!)}>
      {bgImage && (
        <div className={styles.fastFact__imgWrapper}>
          <Image classes={styles.fastFact__img} image={bgImage} />
        </div>
      )}
      <div className={styles.fastFact__content}>
        {logo && (
          <div className={styles.fastFact__content__logoWrapper}>
            <Image classes={styles.fastFact__content__logo} image={logo} />
          </div>
        )}
        <div>
          {eyebrow && (
            <p className={css("eyebrow", styles.fastFact__content__eyebrow)}>
              {eyebrow}
            </p>
          )}

          {headline && (
            <div className={css("stat", styles.fastFact__content__headline)}>
              {headline}
              {trailing && (
                <span className={styles.fastFact__content__trailing}>
                  {trailing}
                </span>
              )}
            </div>
          )}

          {copy && (
            <p className={css("p", styles.fastFact__content__copy)}>{copy}</p>
          )}

          {cta && <CTAButton cta={cta} kind="tertiary" darkMode />}

          {caption && (
            <caption
              className={css("caption", styles.fastFact__content__caption)}
            >
              {caption}
            </caption>
          )}
        </div>
      </div>
    </div>
  );
};

export default FastFact;
